module.exports = __webpack_public_path__ + "27e194bdb7a55ffd4bffb74dfa6c4c65.pdf";